import * as CatalogDownloadType from './catalogUpdateReferences.types';
import { IInitialCatalogUpdateReferencesState } from 'interfaces/catalogUpdateReferences.interface';

export default function catalogUpdateReferencesReducer(
  state: IInitialCatalogUpdateReferencesState,
  action: any
) {
  const { type, payload } = action;

  switch (type) {
    case CatalogDownloadType.SET_CATALOG_ITEMS: {
      const getCatalogItems: IInitialCatalogUpdateReferencesState = {
        ...state,
        catalogItems: payload,
      };
      return getCatalogItems;
    }

    case CatalogDownloadType.SET_FILTERS: {
      const setFilters: IInitialCatalogUpdateReferencesState = {
        ...state,
        filters: payload,
      };
      return setFilters;
    }

    case CatalogDownloadType.SET_IS_LOADING_FILTERS: {
      const setIsLoadingFilters: IInitialCatalogUpdateReferencesState = {
        ...state,
        isLoadingGetFilters: payload,
      };
      return setIsLoadingFilters;
    }

    case CatalogDownloadType.SET_IS_LOADING_CATALOG: {
      const setIsLoadingCatalog: IInitialCatalogUpdateReferencesState = {
        ...state,
        isLoadingCatalog: payload,
      };
      return setIsLoadingCatalog;
    }

    case CatalogDownloadType.SET_SELECTED_VALUES: {
      const setSelectedValues: IInitialCatalogUpdateReferencesState = {
        ...state,
        selectedValues: payload,
      };
      return setSelectedValues;
    }

    case CatalogDownloadType.SET_IS_LOADING_UPDATE_REFERENCES: {
      const setIsLoadingUpdateReferences: IInitialCatalogUpdateReferencesState = {
        ...state,
        isLoadingUpdateReferences: payload,
      };
      return setIsLoadingUpdateReferences;
    }

    case CatalogDownloadType.SET_COLUMNS_ORDER: {
      const setColumnsOrder: IInitialCatalogUpdateReferencesState = {
        ...state,
        columnsOrder: payload,
      };
      return setColumnsOrder;
    }

    default:
      return state;
  }
}
